import * as Yup from 'yup';

const schema = Yup.object({
  orderKfWConfirmation: Yup.string().required(
    'Bitte treffen Sie eine Auswahl.'
  ),
});

export default schema;
